export default __webpack_public_path__ + "static/media/APIrevised2.574c288c.mp4";